import React from "react";
import svg50 from "../../assets/svg/svg50.svg";
import { useSelector } from "react-redux";
function RightSide() {
  const { subdomain } = useSelector((state) => state.global);
  return (
    <div
      className={`hidden lg:flex w-full ${
        subdomain === "ndovupay" || subdomain === "localhost"
          ? "login-ndovu-pic"
          : "login-pic"
      }  px-[3.19rem] py-[4.5rem] flex-col justify-between`}
    >
      <div className="flex flex-col justify-center items-center">
        <div
          className="flex items-center gap-[.62rem] rounded-[6.25rem] border border-white
         bg-white/10 shadow-[4px_1px_4px_0px_rgba(214,158,0,0.15)] p-[.62rem] w-[8.625rem] h-[1.75rem]"
        >
          <img src={svg50} alt="svg50" />
          <span className="font-dmSans font-[500] text-[.75rem] text-white">
            Admin Portal
          </span>
        </div>
        <div className="typography_login_1 mt-[1.25rem]">
          Seamless payment management
        </div>
        <div className="typography_login_2  mt-[.5rem]">
          The fastest way to manage payments across your departments
        </div>
      </div>
      <div className="typography-footer mb-[2rem] flex justify-center">
        Powered by Smart People Africa
      </div>
    </div>
  );
}

export default RightSide;
